import requestJWT from "utils/requestJWT";

const createFavoriteApi = async (data) => {
    return await requestJWT.post(`/favorite/create`, data);
};


const removeFavoriteApi = async (id) => {
    return await requestJWT.delete(`/favorite/${id}/remove`);
};


const getFavoriteApi = async (page, perPage) => {
    return await requestJWT.get(`/favorite/get-all?page=${page}&item=${perPage}`);
};

export {
    createFavoriteApi,
    removeFavoriteApi,
    getFavoriteApi
};
